import { ErrorResponse } from "utils/interfaces"
import { GetBookingDetailsResponse } from "modules/BookingCommon/common/interfaces"
import { httpClient } from "utils/infrastructure/httpClient"

export function getPaidBookingDetails(bookingHash: string | undefined) {
    return httpClient.post<GetBookingDetailsResponse | ErrorResponse>("get-booking-details", {
        booking_hash: bookingHash,
    })
}
